module.exports = __webpack_public_path__ + "img/blog-10-770x420.75b156d2.jpg";